export default function InfoTable({ listData = [], style = {} }) {
    return (
        <>
            {listData.map((row, tr) => {
                return (
                    <div
                        key={tr}
                        style={{
                            display: "table-row",
                            width: "100%",
                            ...style,
                        }}
                    >
                        {row.map((cell, td) => {
                            return (
                                <div
                                    key={td}
                                    style={{
                                        display: "table-cell",
                                        paddingRight: ".5rem",
                                    }}
                                >
                                    {cell}
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
}
